import React, { memo, useMemo } from 'react';
import { Text, useTheme } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';
import TruncatedText from 'components/TruncatedText';

import './styles.scss';

const Suggestions = memo(({ suggestions, onClick, isLoading }) => {
    const theme = useTheme();

    const renderSuggestions = useMemo(() => {
        return suggestions.map((current, index) => {
            return (
                <div
                    key={index}
                    className="dana-chat-suggestion"
                    onClick={() => onClick(current.content)}
                >
                    <TruncatedText color={theme.colors.textLight.primary} avoidEye>
                        {current.content}
                    </TruncatedText>
                </div>
            );
        });
    }, [suggestions, onClick, theme]);

    const renderLoader = useMemo(() => {
        return (
            <div className="dana-chat-suggestion-loader">
                <Text color={theme.colors.semantic.info400}>
                    {getLiteral('label_generating_questions')}
                </Text>
            </div>
        );
    }, [theme]);

    return (
        <div className="dana-chat-suggestion-container">
            {isLoading && renderLoader}
            {!isLoading && renderSuggestions}
        </div>
    );
});

export default Suggestions;
